const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');

function apiFactory({
  baseUrl,
  requestHandler
}) {
  const headers = {
    Accept: 'application/json'
  };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    getCioInsightsData(roleid,count,limit,metaData) {

      const counter = count.replace(/i/gi,'');

      const PageLimit = limit.replace(/i/gi,'');

      // debugger;
      const url = getUrl('dashboard');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        timeout: 120000
      };

      /* Need to pass db entitlement actions*/

      const body = {
        dashboardSection:"Dashboard",
        roleId: roleid.split(','),
        lazyLoadingCounter:counter,
        limit:PageLimit,
        searchCategory:"",
        searchKeyWord:"",
        searchSubCategory:"",
        noOfDays : "",
        userId : parsedMetaData.qs.userId
      };

      return requestHandler(merge(reqOpts,{
        url,
        body,
        json:true
      }));

    },

    getArticle(articleId,metaData) {

      // debugger;


      articleId = articleId.replace(/i/gi,'');
      // debugger;
      const url = getUrl('publication');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        timeout: 120000
      };

      /* Need to pass db entitlement actions*/

      const body = {
        pubId:articleId,
        userId : parsedMetaData.qs.userId
      };

      return requestHandler(merge(reqOpts,{
        url,
        body,
        json:true
      }));

    },

    getAttachment(attachmentId,metaData) {

     

      attachmentId = attachmentId.replace(/i/gi,'');
      // debugger;
      const url = getUrl('fetch-doc');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        timeout: 120000
      };

      /* Need to pass db entitlement actions*/

      const body = {
        attachmentId: attachmentId,
        userId : parsedMetaData.qs.userId
      };

      return requestHandler(merge(reqOpts,{
        url,
        body,
        json:true
      }));

    },
    getCioSearchData(roleid,searchKeyword,lazyLoadingCount,pageLimit,metaData) {
      const counter = lazyLoadingCount.replace(/i/gi,'');
      const PageLimit = pageLimit.replace(/i/gi,'');
      const searchKey = searchKeyword.replace(/!/gi,'');
      const url = getUrl('dashboard');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        timeout: 120000
      };

      const body = {
        dashboardSection: "Dashboard",
        roleId: roleid.split(','),
        lazyLoadingCounter: counter,
        limit: PageLimit,
        searchCategory: "",
        searchKeyWord: searchKey,
        searchSubCategory: "",
        noOfDays : "",
        userId : parsedMetaData.qs.userId

      };
      return requestHandler(merge(reqOpts,{
        url,
        body,
        json:true
      }));

    },


  };
}

module.exports = apiFactory;
